import { Properties } from 'html-element-property-mixins';
import { UpdateStylesMixin } from '../utils/update-styles-mixin';
import { PropertiesChangedCallback, PropertyChangedHandler, PropertiesChangedHandler } from 'html-element-property-mixins/src/addons';
import { html, render as litRender } from 'lit-html/lib/shady-render.js';
import { StyleResizeObserverMixin } from '../utils/style-resize-observer-mixin';

class SlicesUIElement extends StyleResizeObserverMixin(UpdateStylesMixin(PropertiesChangedCallback(PropertyChangedHandler(PropertiesChangedHandler(Properties(HTMLElement)))))) {
  static get properties() {
    return {};
  }

  constructor() {
    super();
    this.attachShadow({mode: 'open'});
    this.observeAndSetStyles();
  }
  
  get template () {
    return html``;
  }

  connectedCallback() {
    super.connectedCallback();
    this.render();
  }

  render() {
    litRender(this.template, this.shadowRoot, {eventContext: this, scopeName: this.localName});
  }

}

export { SlicesUIElement, html };